<template>
  <div :style="{ textAlign: !isActive ? 'center' : 'right' }">
    <i
      v-if="isActive"
      class="el-icon-s-fold"
      alt="收起"
      @click="toggleClick"
    ></i>
    <i v-else class="el-icon-s-unfold" alt="展开" @click="toggleClick"></i>
  </div>
</template>

<script>
export default {
  name: "Hamburger",
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    toggleClick() {
      this.$emit("toggleClick");
    }
  }
};
</script>

<style lang="scss" scoped>
i {
  cursor: pointer;
  font-size: 23px;
}
</style>
